module.exports = __webpack_public_path__ + "img/2019pajero.025cf141.png";